import { render } from "./SquadDutyListBlock.vue?vue&type=template&id=86e0871e"
import script from "./SquadDutyListBlock.vue?vue&type=script&lang=js"
export * from "./SquadDutyListBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__